'use client'

import { create } from 'zustand'

interface BillingDialogState {
  isOpen: boolean
  reason:
    | 'exhausted'
    | 'upgrade'
    | 'manual'
    | 'first_value'
    | 'brand_limit'
    | null
  /** Optional checkout return URLs (absolute or root-relative paths). When set,
   *  useCreateCheckout uses these instead of the default product billing pages —
   *  lets a standalone surface (e.g. a marketing tool page) keep the user on it
   *  after Stripe checkout. Cleared on close. */
  successUrl: string | null
  cancelUrl: string | null
}

interface BillingDialogActions {
  open: (
    reason?: BillingDialogState['reason'],
    opts?: { successUrl?: string; cancelUrl?: string },
  ) => void
  close: () => void
}

type BillingDialogStore = BillingDialogState & BillingDialogActions

export const useBillingDialogStore = create<BillingDialogStore>()(set => ({
  isOpen: false,
  reason: null,
  successUrl: null,
  cancelUrl: null,

  open: (reason = 'manual', opts) =>
    set({
      isOpen: true,
      reason,
      successUrl: opts?.successUrl ?? null,
      cancelUrl: opts?.cancelUrl ?? null,
    }),

  close: () =>
    set({ isOpen: false, reason: null, successUrl: null, cancelUrl: null }),
}))
